import { z } from "zod";
import { decompositionItemSchema } from "./decomposition-item";

export const decompositionSectionSchema = z.object({
  title: z.string(),
  items: z.array(decompositionItemSchema),
});
export type DecompositionSection = z.infer<typeof decompositionSectionSchema>;
